import { money2 } from './common';
import { IconCommission, IconCreditCard, IconHandCash, IconQr } from './icons';

const METHODS = [
  { value: 'cash', label: 'เงินสด', Icon: IconHandCash },
  { value: 'qr_promptpay', label: 'QR PromptPay', Icon: IconQr },
  { value: 'credit_card', label: 'บัตรเครดิต', Icon: IconCreditCard },
  { value: 'agency', label: 'เอเจนซี่', Icon: IconCommission, agencyOnly: true },
];

export default function PaymentMethodPicker({
  method,
  onMethod,
  amount,
  cashReceived,
  onCashReceived,
  waiting,
  allowAgency = false,
}) {
  const change = Number(cashReceived || 0) - Number(amount || 0);

  return (
    <>
      <div className="payment-method-picker" aria-label="ช่องทางการชำระเงิน">
        {METHODS.filter((option) => !option.agencyOnly || allowAgency).map(({ value, label, Icon }) => (
          <button
            key={value}
            type="button"
            className={`payment-method-option${method === value ? ' active' : ''}`}
            onClick={() => onMethod(value)}
            disabled={waiting}
          >
            <Icon size={22} />
            <span>{label}</span>
          </button>
        ))}
      </div>

      {method === 'cash' && (
        <div className="cash-tender">
          <label className="field">
            <span>จำนวนเงินที่ลูกค้าให้</span>
            <input
              type="number"
              min="0"
              step="0.01"
              value={cashReceived}
              onChange={(event) => onCashReceived(event.target.value)}
              disabled={waiting}
            />
          </label>
          <div className={`cash-change${change < 0 ? ' short' : ''}`}>
            <span>เงินทอน</span>
            <strong>
              {change < 0 ? `ขาด ${money2(Math.abs(change))}` : money2(change)}
            </strong>
          </div>
        </div>
      )}

      {waiting && (
        <div className="beam-waiting" role="status">
          <span className="beam-pulse" />
          <div>
            <strong>รอการชำระเงินจาก Beam</strong>
            <span>
              {method === 'credit_card'
                ? 'กรุณาชำระด้วยบัตรบนเครื่อง Beam Bolt'
                : 'กรุณาสแกน QR PromptPay บนเครื่อง Beam Bolt'}
            </span>
          </div>
        </div>
      )}
    </>
  );
}
